<template>
  <div class="modal" v-if="isShowTerms">
    <div class="overlay" />
    <div class="modal-content-wrapper">
      <div class="modal-content">
        <h2 class="terms-title" v-html="$t('text001')" />
        <p class="terms-subtitle" v-html="$t('text002')" />
        <div class="terms-text" v-html="$t('text003', { samelist_url: `/${$route.params.lang}/character` })" />
        <ModalButtonClose @click="hideTerms" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ModalButtonClose from '@components/modals/modal-button-close.vue'
import localeAgreement from '@locales/agreement'

export default {
  name: 'modal',
  $messages: localeAgreement,
  components: {
    ModalButtonClose
  },
  computed: {
    ...mapState('terms', ['isShowTerms']),
  },
  methods: {
    ...mapActions('terms', ['hideTerms'])
  }
}
</script>

<style lang="scss" scoped>
/deep/ a {
  color: #69f;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: .8;
  z-index: 0;;
}

.modal-content-wrapper {
  position: relative;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  width: 100%;
}

.modal-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 10px;
  height: 100%;
  width: 608px;
  box-sizing: border-box;
}

.terms-title {
  text-align: center;
  margin: 40px 0 30px;
  padding: 0 80px;
  line-height: 1.4;
}
.terms-subtitle {
  text-align: center;
  margin-bottom: 30px;
}
.terms-text {
  padding: 40px 0;
}
.modal-button-close {
  top: 12px;
  right: 0;
}
</style>
